import { Codebook } from '../Codebook'

export enum OtaApiPartnerId {
  RESERVATION_PLUS = 1,
  PREVIO_GLOBAL = 5,
  HOTEL_CZ = 7,
  OWNER_AGENCY_SYSTEM = 8,
  PREVIO_AFFILIATE = 57,
  MARKETING_PLUS = 363,
  SLEVOMAT = 1344,
  SPA_CZ = 1390,
  NTS_SLOVAKIA_BOOKIO = 1432,
  SLEVA_DNE_CZ = 1460,
  CEDOK = 1521,
  GOOGLE_HOTEL_SEARCH = 1523,
  TRAVELKING_CZ = 1531,
  OFFER = 1651,
  ALFRED = 1655,
  ZAZITKY_CZ = 1659,
  HAUZI = 1673,
  MEGAUBYTOVANIE_SK_MEGAUBYTKO_CZ = 1675,
  VACATIONZDIAR_SK = 1739,
  KOUZELNECHALOUPKY_CZ = 1741,
  INSPIRAGO = 1745,
  BOOKOLO_SYSTEM = 1747,
  SLEVOMAT_CHM = 1763,
  SZALLAS_GROUP = 1334,
  BOOKING_COM = 770,
}

class OtaApiPartner extends Codebook<OtaApiPartnerId> {
  static readonly RESERVATION_PLUS = new OtaApiPartner(
    OtaApiPartnerId.RESERVATION_PLUS,
    () => 'RESERVATION+',
  )
  static readonly PREVIO_GLOBAL = new OtaApiPartner(
    OtaApiPartnerId.PREVIO_GLOBAL,
    () => 'Previo Global',
  )
  static readonly HOTEL_CZ = new OtaApiPartner(OtaApiPartnerId.HOTEL_CZ, () => 'HOTEL.CZ')
  static readonly OWNER_AGENCY_SYSTEM = new OtaApiPartner(
    OtaApiPartnerId.OWNER_AGENCY_SYSTEM,
    () => 'Owner/Agency system',
  )
  static readonly PREVIO_AFFILIATE = new OtaApiPartner(
    OtaApiPartnerId.PREVIO_AFFILIATE,
    () => 'Previo Affiliate',
  )
  static readonly MARKETING_PLUS = new OtaApiPartner(
    OtaApiPartnerId.MARKETING_PLUS,
    () => 'MARKETING+',
  )
  static readonly SLEVOMAT = new OtaApiPartner(OtaApiPartnerId.SLEVOMAT, () => 'Slevomat')
  static readonly SPA_CZ = new OtaApiPartner(OtaApiPartnerId.SPA_CZ, () => 'SPA.CZ')
  static readonly NTS_SLOVAKIA_BOOKIO = new OtaApiPartner(
    OtaApiPartnerId.NTS_SLOVAKIA_BOOKIO,
    () => 'NTS Slovakia - Bookio',
  )
  static readonly SLEVA_DNE_CZ = new OtaApiPartner(
    OtaApiPartnerId.SLEVA_DNE_CZ,
    () => 'SlevaDne.cz',
  )
  static readonly CEDOK = new OtaApiPartner(OtaApiPartnerId.CEDOK, () => 'ČEDOK')
  static readonly GOOGLE_HOTEL_SEARCH = new OtaApiPartner(
    OtaApiPartnerId.GOOGLE_HOTEL_SEARCH,
    () => 'Google Hotel Search',
  )
  static readonly TRAVELKING_CZ = new OtaApiPartner(
    OtaApiPartnerId.TRAVELKING_CZ,
    () => 'Travelking.cz',
  )
  static readonly OFFER = new OtaApiPartner(OtaApiPartnerId.OFFER, () => 'Offer')
  static readonly ALFRED = new OtaApiPartner(OtaApiPartnerId.ALFRED, () => 'Alfred')
  static readonly ZAZITKY_CZ = new OtaApiPartner(OtaApiPartnerId.ZAZITKY_CZ, () => 'Zazitky.cz')
  static readonly HAUZI = new OtaApiPartner(OtaApiPartnerId.HAUZI, () => 'Hauzi')
  static readonly MEGAUBYTOVANIE_SK_MEGAUBYTKO_CZ = new OtaApiPartner(
    OtaApiPartnerId.MEGAUBYTOVANIE_SK_MEGAUBYTKO_CZ,
    () => 'Megaubytovanie.sk / Megaubytko.cz',
  )
  static readonly VACATIONZDIAR_SK = new OtaApiPartner(
    OtaApiPartnerId.VACATIONZDIAR_SK,
    () => 'Vacationzdiar.sk',
  )
  static readonly KOUZELNECHALOUPKY_CZ = new OtaApiPartner(
    OtaApiPartnerId.KOUZELNECHALOUPKY_CZ,
    () => 'Kouzelnechaloupky.cz',
  )
  static readonly INSPIRAGO = new OtaApiPartner(OtaApiPartnerId.INSPIRAGO, () => 'Inspirago')
  static readonly BOOKOLO_SYSTEM = new OtaApiPartner(
    OtaApiPartnerId.BOOKOLO_SYSTEM,
    () => 'Bookolo system',
  )
  static readonly SLEVOMAT_CHM = new OtaApiPartner(
    OtaApiPartnerId.SLEVOMAT_CHM,
    () => 'Slevomat-CHM',
  )

  static readonly SZALLAS_GROUP = new OtaApiPartner(
    OtaApiPartnerId.SZALLAS_GROUP,
    () => 'Szallas group',
  )

  static readonly BOOKING_COM = new OtaApiPartner(OtaApiPartnerId.BOOKING_COM, () => 'Booking.com')

  private constructor(
    id: OtaApiPartnerId,
    public name: () => string,
  ) {
    super(id)
  }
}

export { OtaApiPartner }
